class ProfileHeaderController {
  constructor() {
    this.header = document.querySelector(".c-studio-header");
    this.lastScrollTop = 0;
    this.scrollThreshold = 10; // スクロール判定の閾値
    this.isHeaderVisible = true;
    this.isMobile = window.innerWidth <= 768;

    this.init();
  }

  init() {
    if (!this.header || !this.isMobile) return;

    // スクロールイベントリスナーを追加
    window.addEventListener("scroll", this.handleScroll.bind(this), { passive: true });

    // リサイズイベントリスナーを追加
    window.addEventListener("resize", this.handleResize.bind(this));

    // 初期状態を設定
    this.header.style.transition = "transform 0.3s ease-in-out";
  }

  handleScroll() {
    if (!this.isMobile) return;

    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDifference = currentScrollTop - this.lastScrollTop;

    // スクロール量が閾値を超えた場合のみ処理
    if (Math.abs(scrollDifference) > this.scrollThreshold) {
      if (scrollDifference > 0 && this.isHeaderVisible) {
        // 下スクロール：ヘッダーを隠す
        this.hideHeader();
      } else if (scrollDifference < 0 && !this.isHeaderVisible) {
        // 上スクロール：ヘッダーを表示
        this.showHeader();
      }

      this.lastScrollTop = currentScrollTop;
    }
  }

  hideHeader() {
    if (!this.isHeaderVisible) return;

    this.header.style.transform = "translateY(-100%)";
    this.isHeaderVisible = false;
  }

  showHeader() {
    if (this.isHeaderVisible) return;

    this.header.style.transform = "translateY(0)";
    this.isHeaderVisible = true;
  }

  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;

    // モバイル状態が変わった場合の処理
    if (wasMobile !== this.isMobile) {
      if (!this.isMobile) {
        // PCになった場合：ヘッダーを表示状態に戻す
        this.header.style.transform = "translateY(0)";
        this.isHeaderVisible = true;
      }
    }
  }
}

// DOMContentLoaded後に初期化
document.addEventListener("DOMContentLoaded", () => {
  new ProfileHeaderController();
});

